module.exports = __webpack_public_path__ + "img/hqzen2.d015cb36.png";